import {
	AddPrivacySolution,
	BlockColdSolution,
	BlockHeatSolution,
	BlockLightSolution,
	BlockNoiseSolution,
	BlockPollutantsSolution,
	BlockUVSolution,
	EnergyEfficiencySolution,
	GovernmentSolution,
	HistoricWindowsSolution,
	HotelSolution,
	OfficeSolution,
	PreventCondensationSolution,
	SaveMoneySolution,
	SpecialtyShapesSolution,
} from '$lib/data/solutions/solutions-data.js';

import {
	AcousticProduct,
	CommercialProduct,
	PrivacyProduct,
	SleepProduct,
	ThermalProduct,
	UvProduct,
} from '$lib/data/products/products-data.js';

const solutions = [
	{
		heading: 'Residential',
		items: [
			BlockNoiseSolution,
			BlockColdSolution,
			BlockHeatSolution,
			SaveMoneySolution,
			EnergyEfficiencySolution,
			PreventCondensationSolution,
			BlockUVSolution,
			BlockLightSolution,
			AddPrivacySolution,
			BlockPollutantsSolution,
			HistoricWindowsSolution,
			SpecialtyShapesSolution,
		],
	},
	{
		heading: 'Commercial',
		items: [HotelSolution, OfficeSolution, GovernmentSolution],
	},
];

const products = [
	{
		heading: 'IndowONE',
		items: [
			ThermalProduct,
			AcousticProduct,
			UvProduct,
			SleepProduct,
			PrivacyProduct,
			CommercialProduct,
		],
	},
];

const howto = [
	{
		title: 'Window Compatibility',
		href: '/guides/indow-window-compatibility',
	},
	{
		title: 'How Inserts Work',
		href: '/how-to/insulate-your-home',
	},
	{
		title: 'How To Order',
		//href: '/how-to/get-indow-inserts',
		href: '/about-indow/how-to-order',
	},
	{
		title: 'How To Measure',
		href: '/self-measure-instructions',
	},
	{
		title: 'How To Install',
		href: '/how-to/install-window-inserts',
	},
	{
		title: 'Snug Fit Guarantee',
		href: '/warranties/snug-fit-guarantee',
	},
	{
		title: 'Lifetime Warranty',
		href: '/warranties/residential-lifetime-warranty',
	},
	{
		title: 'Get Tax Credits',
		href: '/how-to/get-home-energy-efficiency-tax-credits',
	},
	{
		title: 'Increase Resale Value',
		href: '/how-to/increase-home-resale-value',
	},
	{
		title: 'Improve Energy Score',
		href: '/how-to/improve-home-energy-score',
	},
	{
		title: 'Soundproof Your Home',
		href: '/how-to/soundproof-your-home',
	},
	{
		title: 'All Resources',
		href: '/how-to',
	},
];

export { howto, products, solutions };
